import { DialogContent as RMWCDialogContent, DialogContentProps } from "@rmwc/dialog"
import omit from "lodash/omit"
import { ReactNode } from "react"
import { callCSSFn, CSSFn, styled, StylePropsWithCSS } from "../../styles"

type Props = DialogContentProps & {
  css?: CSSFn
  children: ReactNode
}

const Component = (props: Props) => <RMWCDialogContent {...omit(props, `css`)} />

Component.defaultProps = {
  css: undefined,
}

export const DialogContent = styled(Component)((props: StylePropsWithCSS) => ({
  padding: props.theme.spacing(4, 7),
  ...callCSSFn(props),
}))
